import { apiService } from '@/services/APIService';
import { rHandler } from '@/plugins/RHandler';
import { objectsRHandler, DEFAULT_PARAMS } from '@/utils/objectsRHandler';

import Task from '../list/task/index';
import Expert from '../list/expert';

const API_PATH = 'event-polls';

export const TaskManager = {
  objects: {
    ...objectsRHandler(API_PATH, Task),
    copy({ data } = DEFAULT_PARAMS) { // { poll_id: 13907 }
      return rHandler(
        apiService.post(`/${API_PATH}/copy`, data),
        (response) => ({ response, item: new Task(response.data.data, API_PATH) }),
        (error) => ({ error }),
      );
    },
    expertises({ params } = DEFAULT_PARAMS) {
      return rHandler(
        apiService.get(`/${API_PATH}/expertises`, params),
        (response) => ({
          response,
          items: response.data.data.map((i) => new Task(i, `${API_PATH}`)),
        }),
        (error) => ({ error }),
      );
    },
  },

  experts: {
    index({ args, params, obs } = DEFAULT_PARAMS) {
      const [taskId] = args;
      return rHandler(
        apiService.get(`/${API_PATH}/${taskId}/experts`, params),
        (response) => ({
          response,
          items: response.data.data.map((i) => new Expert(i, `${API_PATH}-experts`)),
        }),
        (error) => ({ error }),
        obs,
      );
    },
    add({ args, data, obs } = DEFAULT_PARAMS) {
      const [taskId] = args;
      return rHandler(
        apiService.post(`/${API_PATH}/${taskId}/experts/add`, data),
        (response) => ({ response }),
        (error) => ({ error }),
        obs,
      );
    },
    remove({ args, data, obs } = DEFAULT_PARAMS) {
      const [taskId] = args;
      return rHandler(
        apiService.post(`/${API_PATH}/${taskId}/experts/remove`, data),
        (response) => ({ response }),
        (error) => ({ error }),
        obs,
      );
    },
  },
};
